import { render, staticRenderFns } from "./digital.vue?vue&type=template&id=2aebf52a&scoped=true"
import script from "./digital.vue?vue&type=script&lang=js"
export * from "./digital.vue?vue&type=script&lang=js"
import style0 from "./digital.vue?vue&type=style&index=0&id=2aebf52a&prod&lang=stylus"
import style1 from "./digital.vue?vue&type=style&index=1&id=2aebf52a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aebf52a",
  null
  
)

export default component.exports